import React, { useState } from 'react';
import {
	CancellationData,
	withCancellationContext,
} from '../../context/CancellationProvider';
import { BodyContainer, LayoutContainer, TopContainer } from '../common';
import LargeCenterSpinner from '../LargeCenterSpinner';
import CancellationActions from '../policy/Actions/CancellationActions';
import Breadcrumbs from '../policy/Cancellations/CancellationBreadcrumbs';
import CancellationOverview from '../policy/Cancellations/CancellationOverview';

interface Props {
	children?: JSX.Element | JSX.Element[];
	cancellationData: CancellationData;
}

const CancellationLayout = (props: Props) => {
	const { cancellationData } = props;
	const [loading, setLoading] = useState<boolean>(false);
	props.cancellationData.setLoading = setLoading;

	if (!cancellationData) {
		return <LargeCenterSpinner />;
	}

	return (
		<>
			{loading ? <LargeCenterSpinner /> : null}
			<TopContainer>
				<Breadcrumbs />
				<CancellationActions />
			</TopContainer>
			<LayoutContainer>
				<BodyContainer>
					<CancellationOverview />
					{props.children}
				</BodyContainer>
			</LayoutContainer>
		</>
	);
};

export default withCancellationContext<Props>(CancellationLayout);
